import { render, staticRenderFns } from "./PublicityCenterDetail.vue?vue&type=template&id=6cd95bc6&scoped=true&"
import script from "./PublicityCenterDetail.vue?vue&type=script&lang=js&"
export * from "./PublicityCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./PublicityCenterDetail.vue?vue&type=style&index=0&id=6cd95bc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd95bc6",
  null
  
)

export default component.exports